<div class="minculturas py-3 px-4 md:mb-0 flex " [ngClass]="{
               'flex-column sm:flex-row align-items-center justify-content-between': showButtonLogout , 
            }" style="background-color: #281e52;">
	<img src="assets/layout/images/gov.co_footer.png" alt="Logo ministerio de cultura" width="100" height="20">
	<div class="flex flex-column sm:flex-row align-items-center gap-1 sm:gap-3 mt-3 sm:mt-0" *ngIf="showButtonLogout">
		<div>
			<span class="minculturas-user" style="color: #F0C32B;">{{ 'Vigencia' }} </span>
			<span class="minculturas-user" style="color: #F0C32B;">{{ anioVigencia }}</span>
		</div>
		<div class="hidden sm:block">
			<span class="minculturas-user">-</span>
		</div>
		<div class="flex justify-content-between gap-2">
			<span class="minculturas-user mr-3">{{nombreUsuario}}</span>
			<app-boton-svg [nombre]="'campana'" [color]="'transparete-white'" [size]="'23'" [borderRadius]="'8'"
				[notificationCount]="rejectedCount" (click)="goToRejectedRequests()"
				[pTooltip]="'Solicitudes rechazadas'" tooltipPosition="bottom" />

			<app-boton-svg [nombre]="'usuario'" [color]="'transparete-white'" [size]="'23'" [borderRadius]="'8'"
				(click)="redirectToProfile()" [pTooltip]="'Mi perfil'" tooltipPosition="bottom" />

			<app-boton-svg [nombre]="'logout'" [color]="'transparete-white'" [size]="'23'" [borderRadius]="'8'"
				(click)="onClickLogoutMenu()" [pTooltip]="'Cerrar sesión'" tooltipPosition="bottom" />

			<app-boton-svg [nombre]="'calendario'" [color]="'transparete-white'" [size]="'23'" [borderRadius]="'8'"
				(click)="opValidity.toggle($event)" [pTooltip]="'Vigencia'" tooltipPosition="bottom" />
		</div>
	</div>
</div>
<div class="py-4 px-4 lg:px-8 hidden md:flex align-items-center relative lg:static bg-primary"
	[ngClass]="showButtonLogout ? 'justify-content-between' : 'justify-content-end'">

	<ng-container *ngIf="showButtonLogout">
		<a routerLink="/sigp/modulos/index">
			<img class="minculturas-logo-gestion" src="assets/layout/images/logo-sinic-blanco.svg"
				alt="Logo ministerio de cultura" width="250">
		</a>
	</ng-container>

	<section class="flex align-items-center">
		<img src="assets/layout/images/logo-mincultura.png" alt="Logo ministerio de cultura" width="120">
	</section>
</div>
<p-overlayPanel #opValidity>
	<div class="w-25rem">
		<app-validity *ngIf="showButtonLogout"></app-validity>
	</div>
</p-overlayPanel>